export var RegistrationStatus;

(function (RegistrationStatus) {
  RegistrationStatus["Init"] = "Init";
  RegistrationStatus["Entered"] = "Entered";
  RegistrationStatus["PasswordEntered"] = "PasswordEntered";
  RegistrationStatus["Completed"] = "Completed";
})(RegistrationStatus || (RegistrationStatus = {}));